import { getAnnouncements, storeAnnouncement, showAnnouncement, updateAnnouncement, deleteAnnouncement } from '@/api'
import router from '@/router';

export default {
    namespaced: true,
    state: {
        announcements: [],
        announcement: {},
        visibleCreate: false,
        isLoading: false
    },
    mutations: {
        SET_ANNOUNCEMENT: (state, announcement) => state.announcement = announcement,
        SET_ANNOUNCEMENTS: (state, announcements) => state.announcements = announcements,
        SET_VISIBLE_CREATE: (state, visible) => state.visibleCreate = visible,
        SET_LOADING: (state, loading) => state.isLoading = loading
    },
    actions: {
        /**
         *
         * @param {function} commit
         * @param {int} page
         */
        get({ commit }, page = 1) {
            commit('SET_LOADING', true);

            getAnnouncements(page)
                .then(res => commit('SET_ANNOUNCEMENTS', res.data.data))
                .finally(() => {
                    commit('SET_VISIBLE_CREATE', false);
                    commit('SET_LOADING', false)
                })
        },

        /**
         * @param {function} commit
         * @param {{ title: string, content: string, user_id: int, id: int }} announcement
         * @param {int} id
         */
        show({ commit, state: { announcement } }, id) {
            if (!Object.keys(announcement).length) {

                commit('SET_LOADING', true);

                showAnnouncement(id)
                    .then(res => {
                        commit('SET_ANNOUNCEMENT', res.data);
                        if (router.history.current.query.page && router.history.current.query.page !== page) {
                            router.push({ name: router.history.current.name, query: { page } });
                        }
                    })
                    .finally(() => commit('SET_LOADING', false))
            }
        },

        /**
         *
         * @param {function} commit
         * @param {{ title: string, content: string, user_id: int, id: int }} announcement
         */
        set({ commit }, announcement) {
            commit('SET_ANNOUNCEMENT', announcement)
        },

        /**
         *
         * @param {function} dispatch
         * @param {function} commit
         * @param {{ title: string, content: string, user_id: int, cb: function }} announcement
         */
        store({ dispatch, commit }, announcement) {
            commit('SET_LOADING', true);

            storeAnnouncement(announcement)
                .then(() => {
                    announcement.cb();
                    delete announcement.cb;
                    dispatch('get')
                })
        },

        /**
         *
         * @param {function} dispatch
         * @param {function} commit
         * @param {{ title?: string, content?: string, user_id: int, id: int }} announcement
         */
        update({ dispatch, commit }, announcement) {
            commit('SET_LOADING', true);
            updateAnnouncement(announcement)
                .then(() => dispatch('get'))
        },

        /**
         *
         * @param dispatch
         * @param commit
         * @param {{ title: string, content: string, user_id: int, id: int }} announcement
         */
        delete({ dispatch, commit }, announcement) {
            commit('SET_LOADING', true);
            deleteAnnouncement(announcement.id)
                .then(() => dispatch('get'))
        },
    },
    getters: {}
}